<template>
  <v-dialog persistent v-model="dialog" width="600">
    <template v-slot:activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on">
        <slot />
      </span>
    </template>
    <v-card>
      <v-card-title class="text-h5 green lighten-3">
        <span>User informations : {{ username }}</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col md="3"><strong>Username</strong></v-col>
          <v-col>{{ username }}</v-col>
        </v-row>
        <v-row>
          <v-col md="3"><strong>Password</strong></v-col>
          <v-col><privilege-password-element /></v-col>
        </v-row>
        <v-row>
          <v-col md="3"><strong>Connection String</strong></v-col>
          <v-col>{{ connectionString }}</v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="orange" @click="confirm">
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import PrivilegePasswordElement from './PrivilegePasswordElement.vue';

const { mapActions, mapState } = createNamespacedHelpers('atlasadmin');
export default {
  components: { PrivilegePasswordElement },
  name: 'PrivilegePassword',
  data() {
    return {
      dialog: true,
      clipboardCopied: false,
      timeout: 100
    };
  },
  computed: {
    ...mapState(['password', 'clusters']),
    username() {
      return this.password !== null ? this.password.username : '';
    },
    connectionString() {
      return this.clusters.length > 0 ? this.clusters[0].srvAddress : '---';
    }
  },
  methods: {
    ...mapActions(['removePasswordState']),
    async confirm() {
      try {
        await this.removePasswordState();
        this.dialog = false;
      } catch (err) {
        this.dialog = false;
      }
    }
  }
};
</script>

<style></style>
